import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  timeValueToDate,
  inputNumberAutoComma,
  sort,
  sortReverse,
} from '../../lib/commonFunc/commonFunc';
import Pagination from '@material-ui/lab/Pagination';
import palette from '../../lib/styles/palette';
import DeleteModal from '../common/DeleteModal'
import ItemTypes from '../prescription/ItemTypes';
import { TiArrowSortedDown, TiArrowSortedUp } from 'react-icons/ti';

const MobileProductContainer = styled.div`
    width: 100%;
    height: fit-content;
`;

const MobileProductBox = styled.div`
    width: 100%;
    height: fit-content;

    &:nth-child(1) {
        margin-bottom: 50px;
    }
`;

const TitleBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`;

const Title = styled.div`
    font-weight: bold;
    font-size: 1.1rem;
`;

const BtnAddMobileProduct = styled.button`
    border: 0;
    background-color: ${palette.webCyan[5]};
    border-radius: .2rem;
    color: #fff;
    font-weight: bold;
    font-size: 1rem;
    width: 110px;
    height: 35px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:focus {
        outline: none;
    }

    svg {
        font-size: 1.5rem;
        color: #4d4d4d;
    }
`;

const MobileProductListTop = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #f8f8f8;
    border: 1px solid ${palette.webGray[16]};
    border-top-right-radius: .5rem;
    border-top-left-radius: .5rem;
    border-bottom: 0;
    padding: 16px 0;
    font-weight: bold;
    & .MobileProductInfo {
        width: 65%;
    }
    & .btnBox {
        width: 20%;
    }
    & .sortNum {
        width: 15%;
    }
`;

const MobileProductList = styled.ul`
    border: 1px solid ${palette.webGray[16]};
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem;
`;

const MobileProductNullBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    color: ${palette.webGray[8]};
    font-size: .95rem;
`

const MobileProductItem = styled.li`
    display: flex;
    align-items: center;
    position: relative;
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid ${palette.webGray[16]};
    cursor: pointer;

    &:hover {
        background-color: ${palette.webGray[17]};
    }
    

    & .background {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: -1;
    }
    
    & {
        z-index: 3;
    }

    &:nth-child(1) {
        border-top: 0;
    }

    & .sortNum {
        width: 15%;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        & .num {
            margin-right: 10px;
            font-size: 1.2rem;
            font-weight: bold;
        }

        & .btnSort {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            & svg {
                font-size: 1.4rem;
                color: ${palette.webCyan[5]};
                cursor: pointer;
            }
        }
    }
    & .MobileProductInfo {
        width: 65%;
        height: 100%;
        padding: 0 10px 0 50px;

        & .sort {
            display: flex;
            align-items: center;
            height: 100%;

            & div {
                padding: 3px 0;
            }

            & .block {
                padding: 0;
                height: 20px;
                width: 8px;
                border-radius: .1rem;
                background-color: ${palette.webCyan[5]};
                margin-right: 10px;
            }

            & .sub {
                width: 100px;
                text-align: left;
                font-size: .95rem;
                font-weight: bold;
            }
            
            & .content {
                font-size: .95rem;
            }
        }
    }
    & .btnBox {
        width: 20%;
        padding: 0 10px;

        & .using {
            padding: 5px 0;
            border-radius: .2rem;
            border: 1px solid ${palette.webGray[5]};
            width: 70px;
            background-color: #fff;
            margin-right: 20px;
            cursor: pointer;
            color: #000;

            &:focus {
                outline: none;
            }
        }

        & .unusing {
            padding: 5px 0;
            border-radius: .2rem;
            border: 1px solid ${palette.webGray[5]};
            width: 100px;
            background-color: #fff;
            margin-right: 20px;
            cursor: pointer;
            color: #000;

            &:focus {
                outline: none;
            }
        }

        & .delete {
            padding: 5px 0;
            border-radius: .2rem;
            border: 0;
            width: 70px;
            background-color: ${palette.webGray[5]};
            cursor: pointer;
            color: #fff;

            &:focus {
                outline: none;
            }
        }
    }
`;


const KioskProductManagement = ({salesInfo, onClickRegist, onClickSetting, mobileProductState, onChangeMobileProductState, onChangeProductOrder, mobileProductList, onDeleteMobileProduct, deleteProduct, setDeleteProduct, onChangeIsActive, onClickMobileProduct}) => {
    const [deleteModal, setDeleteModal] = useState(false)
    const [activeItemPage, setActiveItemPage] = useState(1)
    const [itemPage, setItemPage] = useState(1)
    
    const activeAlert = () => alert("판매중인 상품은 수정이 불가능합니다.")

    const decodeOption = (optionJson) => {
        if(optionJson) {
            let temp = JSON.parse(optionJson)

            if(temp && temp.length > 0){
                let option = temp.map(item => {return item.name}).join(", ")
                return option
            } else {
                return "-"
            }
        } else {
            return "-"
        }
    }

    return(
        <>
        <MobileProductContainer>
            <MobileProductBox>
                <TitleBox style={{alignItems: 'flex-end'}}>
                    <Title>판매중인 상품</Title>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        {mobileProductState === 0 && <div style={{marginRight: '20px', fontWeight: 'normal', width: '300px', padding: '7px 10px', border: '1px solid #c4c4c4', borderRadius: '.2rem', fontSize: '.75rem', color: palette.webCyan[5], backgroundColor: '#fff'}}>키오스크 상품 미사용중입니다.<br/>사용하려면 설정에서 사용 상태로 변경해주세요.</div>}
                        <BtnAddMobileProduct onClick={() => onClickRegist()}>상품 등록</BtnAddMobileProduct>
                        <BtnAddMobileProduct onClick={() => onClickSetting()} style={{marginLeft: '20px', border: '1px solid #cccccc', backgroundColor: '#fff', color: '#4d4d4d'}}>
                            키오스크 설정
                        </BtnAddMobileProduct>
                    </div>
                </TitleBox>
                <MobileProductListTop>
                    <li className="sortNum">순서</li>
                    {/* <li className="MobileProductImage">대표 사진</li> */}
                    <li className="MobileProductInfo">상품 정보</li>
                    <li className="btnBox"></li>
                </MobileProductListTop>
                <MobileProductList>
                    {mobileProductList.filter(item => {return item.isActive == 1}).length > 0 ?
                    mobileProductList.filter(item => {return item.isActive == 1}).map((item, idx) => {
                    if(activeItemPage * 10 >= idx + 1 && idx >= (activeItemPage - 1) * 10 ) {
                    return(
                        <MobileProductItem key={idx}>
                            <div onClick={() => onClickMobileProduct(item)} className="background"></div>
                            <div className="sortNum">
                                <div className="num">{item.order}</div>
                                <div className="btnSort">
                                    {mobileProductList.filter(item => {return item.isActive})[0].clubKioskSalesItemID !== item.clubKioskSalesItemID && <TiArrowSortedUp onClick={() => onChangeProductOrder(item.clubKioskSalesItemID, -1)}/>}
                                    {mobileProductList.filter(item => {return item.isActive})[mobileProductList.filter(item => {return item.isActive}).length - 1].clubKioskSalesItemID !== item.clubKioskSalesItemID && <TiArrowSortedDown onClick={() => onChangeProductOrder(item.clubKioskSalesItemID, 1)}/>}
                                </div>
                            </div>
                            <div style={{width: '15%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}/>
                            <div  onClick={() => {onClickMobileProduct(item)}} className="MobileProductInfo">
                                <div className="sort">
                                    <div className="sub">제목</div>
                                    <div className="content" style={{color: palette.webCyan[5], fontWeight: 'bold'}}>{item.title}</div>
                                </div>
                                <div className="sort">
                                    <div className="sub">회원권</div>
                                    <div className="content">{item.subTitle}</div>
                                </div>
                                <div className="sort">
                                    <div className="sub">판매 가격</div>
                                    <div className="content">{inputNumberAutoComma(item.salePrice)}원 {item.salePrice !== item.originPrice && <span>(할인 전 가격 : {item.originPrice}원 / 할인률 : {100 - Math.round((item.salePrice / item.originPrice * 100))}%)</span>}</div>
                                </div>
                                <div className="sort">
                                    <div className="sub">판매 옵션</div>
                                    <div className="content">{decodeOption(item.option)}</div>
                                </div>
                            </div>
                            <div className="btnBox">
                                <button style={{margin: 0}} onClick={() => onChangeIsActive(item.clubKioskSalesItemID, 0)} className="unusing">비활성화</button>
                            </div>
                        </MobileProductItem>
                    )}}) : <MobileProductNullBox>판매중인 상품이 없습니다.</MobileProductNullBox>}
                </MobileProductList>
            </MobileProductBox>
            <div style={{display: 'flex', width: '100%', marginTop: '40px', marginBottom: '80px',justifyContent: 'center'}}>
                <Pagination 
                    count={Math.ceil(mobileProductList.filter(item => {return item.isActive == 1}).length / 10)} 
                    page={activeItemPage}
                    size="large"
                    showFirstButton 
                    showLastButton
                    onChange={(event, value) => {if(value !== activeItemPage) {
                        setActiveItemPage(value)
                    }}}
                />
            </div>
            <MobileProductBox>
                <TitleBox>
                    <Title>미판매중인 상품</Title>
                </TitleBox>
                <MobileProductListTop>
                    <li className="sortNum">순서</li>
                    <li className="MobileProductInfo">상품 정보</li>
                    <li className="btnBox"></li>
                </MobileProductListTop>
                <MobileProductList>
                    {mobileProductList.filter(item => {return item.isActive == 0}).length > 0 ?
                    sortReverse(mobileProductList.filter(item => {return item.isActive == 0}), "title").map((item, idx) => {
                    if(itemPage * 10 >= idx + 1 && idx >= (itemPage - 1) * 10 ) {
                    return(
                        <MobileProductItem key={idx}>
                            <div onClick={() => {onClickMobileProduct(item)}} className="background"></div>
                            <div className="sortNum">
                                <div className="num">-</div>
                            </div>
                            <div style={{width: '15%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}/>
                            <div  onClick={() => {onClickMobileProduct(item)}} className="MobileProductInfo">
                                <div className="sort">
                                    <div className="sub">제목</div>
                                    <div className="content" style={{fontWeight: 'bold', color: palette.webCyan[5]}}>{item.title}</div>
                                </div>
                                <div className="sort">
                                    <div className="sub">회원권</div>
                                    <div className="content">{item.subTitle}</div>
                                </div>
                                <div className="sort">
                                    <div className="sub">판매 가격</div>
                                    <div className="content">{inputNumberAutoComma(item.salePrice)}원 {item.salePrice !== item.originPrice && <span>(할인 전 가격 : {item.originPrice}원 / 할인률 : {100 - Math.round((item.salePrice / item.originPrice * 100))}%)</span>}</div>
                                </div>
                                <div className="sort">
                                    <div className="sub">판매 옵션</div>
                                    <div className="content">{decodeOption(item.option)}</div>
                                </div>
                            </div>
                            <div className="btnBox">
                                <button onClick={() => onChangeIsActive(item.clubKioskSalesItemID, 1)} className="using">활성화</button>
                                <button onClick={() => {
                                    setDeleteProduct(item)
                                    setDeleteModal(true)
                                }} className="delete">삭제</button>
                            </div>
                        </MobileProductItem>
                    )}}) : <MobileProductNullBox>미판매중인 상품이 없습니다.</MobileProductNullBox>}
                </MobileProductList>
            </MobileProductBox>
            <div style={{display: 'flex', width: '100%', marginTop: '40px', justifyContent: 'center'}}>
                <Pagination 
                    count={Math.ceil(mobileProductList.filter(item => {return item.isActive == 0}).length / 10)} 
                    page={itemPage}
                    size="large"
                    showFirstButton 
                    showLastButton
                    onChange={(event, value) => {if(value !== itemPage) {
                        setItemPage(value)
                    }}}
                />
            </div>
        </MobileProductContainer>
        <DeleteModal
        text={`${deleteProduct.salesType == 100?'구독 상품을 삭제하면 기존 구독회원의 구독이 정지됩니다.\n\n':''}${deleteProduct.title} 상품을 삭제하시겠습니까?`}
        modal={deleteModal}
        onClick={() => {
            onDeleteMobileProduct();
            setDeleteModal(false);
        }}
        mb={deleteProduct.salesType == 100?50:10}
        setModal={() => {
            setDeleteModal(false)
            setDeleteProduct({})
        }}
        />
        </>
    )
};

export default KioskProductManagement;

